export const APP_NAME = 'photo-vault';
export const APP_VERSION = 1;
export const VERIFIER_INFO = 'photo-vault/v1/verifier';
export const PBKDF2_ITERATIONS = 250_000;
export const SALT_BYTES = 16;
export const VERIFIER_BITS = 256;
export const MULTIPART_PART_SIZE_BYTES = 8 * 1024 * 1024;
export const MULTIPART_MAX_PARTS = 10_000;
export const UPLOAD_BATCH_MAX_FILES = 100;
export const DOWNLOAD_BATCH_MAX_FILES = 200;
export const RECOVERY_CODE_GROUPS = 12;
export const RECOVERY_CODE_GROUP_LEN = 4;
// Bucket onboarding (Phase 2). The CFN stack name and role name must be
// deterministic so the backend can reconstruct the role ARN from the user's
// 12-digit account id alone — the user never has to copy the ARN by hand.
export const ONBOARDING_STACK_NAME = 'PhotoVault';
export const ONBOARDING_ROLE_NAME = `${ONBOARDING_STACK_NAME}-backend-role`;
// Storage naming intentionally opaque: bucket prefix, tag key and sentinel
// key avoid leaking the "photo-vault" brand on the user's S3. The container
// already hides per-file metadata (WCV v2), so the path/tag layer should
// match. Stack name and role name remain branded — they are onboarding UX
// the user sees and approves in their own AWS account.
export const ONBOARDING_TAG_KEY = 'pvUid';
export const ONBOARDING_BUCKET_NAME_PREFIX = 'pv-';
export const ONBOARDING_SENTINEL_KEY = '__sentinel';
// Cross-account EventBridge wiring (0.7.1). The customer-side rule forwards
// `s3:Object Created` to this custom bus on the app account; the bus's
// resource policy authorises any role named EVENT_FORWARDER_ROLE_NAME so we
// don't have to re-policy on every onboarding.
export const CUSTOMER_EVENT_BUS_NAME = 'pv-customer-events';
export const EVENT_FORWARDER_ROLE_NAME = `${ONBOARDING_STACK_NAME}-event-forwarder-role`;
//# sourceMappingURL=index.js.map